import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer style={{
            backgroundColor: '#ffffff',
            borderTop: '1px solid #f1e2f1',
            color: '#475569',
            paddingTop: '64px',
            paddingBottom: '36px'
        }}>
            <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 20px' }}>
                {/* 4 COLUMN FOOTER GRID */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                    gap: '40px',
                    marginBottom: '48px'
                }}>
                    {/* Brand Column */}
                    <div>
                        <Link to="/" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                            <span style={{
                                fontSize: '1.6rem',
                                fontWeight: 800,
                                color: '#850C85',
                                letterSpacing: '-0.5px'
                            }}>
                                Reliep
                            </span>
                            <span style={{
                                background: '#fbf2fb',
                                color: '#850C85',
                                fontSize: '0.72rem',
                                fontWeight: 800,
                                padding: '3px 8px',
                                borderRadius: '6px',
                                border: '1px solid #ebd0eb'
                            }}>
                                24/7 CARE
                            </span>
                        </Link>
                        <p style={{ fontSize: '0.9rem', lineHeight: 1.6, color: '#64748b', margin: '0 0 20px' }}>
                            India's leading hyperlocal everyday services platform. Book verified expert repairs, cleaning, salon, and transport at transparent rates in just 30 minutes.
                        </p>
                        <div style={{ display: 'flex', gap: '12px' }}>
                            {[
                                { name: 'Facebook', url: 'https://www.facebook.com/reliepindia', icon: '🌐' },
                                { name: 'Instagram', url: 'https://www.instagram.com/reliepindia', icon: '📸' },
                                { name: 'LinkedIn', url: 'https://www.linkedin.com/company/reliep', icon: '💼' }
                            ].map((s, idx) => (
                                <a
                                    key={idx}
                                    href={s.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                        width: '36px',
                                        height: '36px',
                                        borderRadius: '10px',
                                        background: '#fbf2fb',
                                        color: '#850C85',
                                        border: '1px solid #ebd0eb',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '1rem',
                                        textDecoration: 'none',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    {s.icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 style={{ fontSize: '0.95rem', fontWeight: 800, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '18px' }}>
                            Explore
                        </h4>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '0.9rem' }}>
                            <li><Link to="/" style={{ color: '#64748b', textDecoration: 'none', transition: 'color 0.2s' }}>Home</Link></li>
                            <li><Link to="/services" style={{ color: '#64748b', textDecoration: 'none' }}>All Doorstep Services</Link></li>
                            <li><Link to="/about-us" style={{ color: '#64748b', textDecoration: 'none' }}>About Reliep</Link></li>
                            <li><Link to="/contact-us" style={{ color: '#64748b', textDecoration: 'none' }}>Contact & Support</Link></li>
                            <li><Link to="/blog" style={{ color: '#64748b', textDecoration: 'none' }}>Blog & Guides</Link></li>
                            <li><Link to="/cart" style={{ color: '#64748b', textDecoration: 'none' }}>My Cart</Link></li>
                        </ul>
                    </div>

                    {/* For Partners (Crucial!) */}
                    <div>
                        <h4 style={{ fontSize: '0.95rem', fontWeight: 800, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '18px' }}>
                            For Partners
                        </h4>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '0.9rem' }}>
                            <li>
                                <Link
                                    to="/become-a-partner"
                                    style={{
                                        color: '#850C85',
                                        fontWeight: 700,
                                        textDecoration: 'none',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}
                                >
                                    <span>🤝</span>
                                    <span>Become a Partner</span>
                                </Link>
                            </li>
                            <li>
                                <a
                                    href="http://localhost:8100/login"
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ color: '#64748b', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                                >
                                    <span>Partner App Login</span>
                                    <span style={{ fontSize: '0.75rem' }}>↗</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="http://localhost:8100/orders"
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ color: '#64748b', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                                >
                                    <span>Partner Order Dashboard</span>
                                    <span style={{ fontSize: '0.75rem' }}>↗</span>
                                </a>
                            </li>
                            <li><Link to="/contact-us" style={{ color: '#64748b', textDecoration: 'none' }}>Partner Support Desk</Link></li>
                        </ul>
                    </div>

                    {/* Legal & Contact Info */}
                    <div>
                        <h4 style={{ fontSize: '0.95rem', fontWeight: 800, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '18px' }}>
                            Help & Legal
                        </h4>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '0.9rem' }}>
                            <li><Link to="/terms-conditions" style={{ color: '#64748b', textDecoration: 'none' }}>Terms & Conditions</Link></li>
                            <li><Link to="/privacy-policy" style={{ color: '#64748b', textDecoration: 'none' }}>Privacy Policy</Link></li>
                            <li><Link to="/refund-policy" style={{ color: '#64748b', textDecoration: 'none' }}>Cancellation & Refund</Link></li>
                            <li style={{ color: '#0f172a', fontWeight: 600, marginTop: '8px' }}>
                                📞 1800-RELIEP (Toll-Free)
                            </li>
                            <li style={{ color: '#64748b' }}>
                                ✉️ support@reliep.com
                            </li>
                        </ul>
                    </div>
                </div>

                {/* BOTTOM STRIP */}
                <div style={{
                    borderTop: '1px solid #f1e2f1',
                    paddingTop: '24px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '16px',
                    fontSize: '0.85rem',
                    color: '#94a3b8'
                }}>
                    <p style={{ margin: 0 }}>
                        &copy; {new Date().getFullYear()} Reliep Technologies Private Limited. All rights reserved.
                    </p>
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <Link to="/privacy-policy" style={{ color: '#94a3b8', textDecoration: 'none' }}>Privacy</Link>
                        <Link to="/terms-conditions" style={{ color: '#94a3b8', textDecoration: 'none' }}>Terms</Link>
                        <Link to="/refund-policy" style={{ color: '#94a3b8', textDecoration: 'none' }}>Refunds</Link>
                        <Link to="/become-a-partner" style={{ color: '#850C85', fontWeight: 700, textDecoration: 'none' }}>Join as Partner</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
